/*
 *
 * Home constants
 *
 */

export const GET_COUNTER_REQUESTED = "counter/GET_COUNTER_REQUESTED";
export const GET_COUNTER_SUCCESS = "counter/GET_COUNTER_SUCCESS";
export const GET_COUNTER_FAILED = "counter/GET_COUNTER_FAILED";

export const SET_VIEW_BANNER_REQUESTED = "counter/SET_VIEW_BANNER_REQUESTED";
export const SET_VIEW_BANNER_SUCCESS = "counter/SET_VIEW_BANNER_SUCCESS";
export const SET_VIEW_BANNER_FAILED = "counter/SET_VIEW_BANNER_FAILED";

